/**
 * This will produce a string of the form 
 * '<path0>/<path1>/...<pathN>'. 
 * @param {Array} ...paths the elements to form into the key.  
 */
function forSettings(...paths) {
  return paths.join('/');
}

/**
 * This will produce a string of the form 
 * '<persona>.<path0>.<path1>...<pathN>'. If persona
 * is null, 'default will be used.
 * @param {Object|String} match the match object or persona name
 * @param {Array} ...paths the elements to form into the key.  
 */
function usingPersona(match, ...paths) {
  const persona = typeof matchOrPersona === 'string' ? match : match?.params?.persona;
  return `${persona}.${paths.join('.')}`;
}
export default {
  forSettings,
  usingPersona
};